import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import {AuthCheck} from '../../helpers'
import {
  GetAllRecordHistoryClient,
  GetAllNoteClient,
  GetAllNoteImagesClient,
  DeleteNoteClient,
  CreateNoteClient,
  GlobalSearchClient,
  GeneralDashboardClient,
  BankCashDashboardClient,
  GetAllActivityClient,
  DeleteFileClient,
  DeleteFileFolderClient,
  CreateFileFolderClient,
  CreateFileClient,
  RenameFileFolderClient,
  GetAllFolderWithFilesClient,
  GetRootFileFolderIdClient,
  GetFileFolderClient,
  UpdateFileFolderClient,
  AssignFileFolderPermissionClient,
  GetFileFolderPermissionClient,
  RenameFileClient,
  GetCurrencyInfosClient,
  MuteFileFolderClient,
  UnmuteFileFolderClient,
} from '../../api'

const SERVICE_URL = window.ENVVARS.REACT_APP_SERVICE_URL

const getAllRecordHistoryClient = new GetAllRecordHistoryClient(SERVICE_URL)
const getAllNoteClient = new GetAllNoteClient(SERVICE_URL)
const getAllNoteImagesClient = new GetAllNoteImagesClient(SERVICE_URL)
const createNoteClient = new CreateNoteClient(SERVICE_URL)
const deleteNoteClient = new DeleteNoteClient(SERVICE_URL)
const globalSearchClient = new GlobalSearchClient(SERVICE_URL)
const generalDashboardClient = new GeneralDashboardClient(SERVICE_URL)
const bankCashDashboardClient = new BankCashDashboardClient(SERVICE_URL)
const getAllActivityClient = new GetAllActivityClient(SERVICE_URL)
const deleteFileClient = new DeleteFileClient(SERVICE_URL)
const deleteFileFolderClient = new DeleteFileFolderClient(SERVICE_URL)
const createFileFolderClient = new CreateFileFolderClient(SERVICE_URL)
const createFileClient = new CreateFileClient(SERVICE_URL)
const renameFileFolderClient = new RenameFileFolderClient(SERVICE_URL)
const getAllFolderWithFilesClient = new GetAllFolderWithFilesClient(SERVICE_URL)
const getRootFileFolderIdClient = new GetRootFileFolderIdClient(SERVICE_URL)
const getFileFolderClient = new GetFileFolderClient(SERVICE_URL)
const updateFileFolderClient = new UpdateFileFolderClient(SERVICE_URL)
const assignFileFolderPermissionClient = new AssignFileFolderPermissionClient(SERVICE_URL)
const getFileFolderPermissionClient = new GetFileFolderPermissionClient(SERVICE_URL)
const renameFileClient = new RenameFileClient(SERVICE_URL)
const currencyInfosClient = new GetCurrencyInfosClient(SERVICE_URL)
const muteFileFolderClient = new MuteFileFolderClient(SERVICE_URL)
const unmuteFileFolderClient = new UnmuteFileFolderClient(SERVICE_URL)

const initialState = {
  loading: false,
  isRedirect: false,
  error: null,
  isDeleted: false,
  isArchived: false,
  activity: [],
  getFileFolderId: null,
  history: null,
  note: null,
  noteImages: null,
  noteCreated: null,
  search: null,
  generalDashResult: null,
  bankCashDashResult: null,
  currencyInfos: null,
  file: null,
  fileFolder: null,
  getAllWithFiles: null,
  getAllOnlyFolder: null,
  updateFolder: null,
  assignFileFolderPermission: null,
  fileFolderPermission: null,
  muteFileFolderResult: null,
  unmuteFileFolderResult: null,
}

// Async Thunks
export const historyGetAll = createAsyncThunk(
  'common/historyGetAll',
  async (params, {dispatch}) => {
    try {
      dispatch(setLoading(true))
      const response = await getAllRecordHistoryClient.getAll(params)
      dispatch(setHistory(response))
      return response
    } catch (error) {
      AuthCheck(error)
      dispatch(setError(error))
      throw error
    }
  }
)

export const noteGetAll = createAsyncThunk('common/noteGetAll', async (params, {dispatch}) => {
  try {
    dispatch(setLoading(true))
    dispatch(setNote(null))
    const response = await getAllNoteClient.getAll(params)
    dispatch(setNote(response))
    return response
  } catch (error) {
    AuthCheck(error)
    dispatch(setError(error))
    throw error
  }
})

export const noteGetAllImages = createAsyncThunk(
  'common/noteGetAllImages',
  async (params, {dispatch}) => {
    try {
      dispatch(setLoading(true))
      const response = await getAllNoteImagesClient.getAllNoteImages(params)
      dispatch(setNoteImages(response))
      return response
    } catch (error) {
      AuthCheck(error)
      dispatch(setError(error))
      throw error
    }
  }
)

export const noteCreate = createAsyncThunk(
  'common/noteCreate',
  async (params, {dispatch}) => {
    try {
      dispatch(setLoading(true))
      const response = await createNoteClient.create(params.Description, params.SourceId, params.SourceTypeId, params.File)
      dispatch(setNoteCreated(response))
      return response
    } catch (error) {
      AuthCheck(error)
      dispatch(setError(error))
      throw error
    }
  }
)

export const noteDelete = createAsyncThunk('common/noteDelete', async (params, {dispatch}) => {
  try {
    dispatch(setLoading(true))
    const response = await deleteNoteClient.delete(params)
    dispatch(setDeleted(response || true))
    return response
  } catch (error) {
    AuthCheck(error)
    dispatch(setError(error))
    throw error
  }
})

export const globalSearch = createAsyncThunk('common/globalSearch', async (params, {dispatch}) => {
  try {
    dispatch(setLoading(true))
    const response = await globalSearchClient.getAll(params)
    dispatch(setSearch(response))
    return response
  } catch (error) {
    AuthCheck(error)
    dispatch(setError(error))
    throw error
  }
})

export const generalDashboard = createAsyncThunk(
  'common/generalDashboard',
  async (params, {dispatch}) => {
    try {
      dispatch(setLoading(true))
      const response = await generalDashboardClient.get(params)
      dispatch(setGeneralDashResult(response))
      return response
    } catch (error) {
      AuthCheck(error)
      dispatch(setError(error))
      throw error
    }
  }
)

export const getCurrencyInfos = createAsyncThunk(
  'common/getCurrencyInfos',
  async (params, {dispatch}) => {
    try {
      const response = await currencyInfosClient.getAll(params)
      dispatch(setCurrencyInfos(response))
      return response
    } catch (error) {
      AuthCheck(error)
      dispatch(setError(error))
      throw error
    }
  }
)

export const bankCashDashboard = createAsyncThunk(
  'common/bankCashDashboard',
  async (params, {dispatch}) => {
    try {
      dispatch(setLoading(true))
      const response = await bankCashDashboardClient.get(params)
      dispatch(setBankCashDashResult(response))
      return response
    } catch (error) {
      AuthCheck(error)
      dispatch(setError(error))
      throw error
    }
  }
)

export const activityGetAll = createAsyncThunk(
  'common/activityGetAll',
  async (params, {dispatch}) => {
    try {
      dispatch(setLoading(true))
      const response = await getAllActivityClient.getAll(params)
      dispatch(setActivity(response))
      return response
    } catch (error) {
      AuthCheck(error)
      dispatch(setError(error))
      throw error
    }
  }
)

export const fileDelete = createAsyncThunk('common/fileDelete', async (params, {dispatch}) => {
  try {
    dispatch(setLoading(true))
    const response = await deleteFileClient.delete(params)
    dispatch(setDeleted(response))
    return response
  } catch (error) {
    AuthCheck(error)
    dispatch(setError(error))
    throw error
  }
})

export const fileFolderDelete = createAsyncThunk(
  'common/fileFolderDelete',
  async (params, {dispatch}) => {
    try {
      dispatch(setLoading(true))
      const response = await deleteFileFolderClient.delete(params)
      dispatch(setDeleted(response))
      return response
    } catch (error) {
      AuthCheck(error)
      dispatch(setError(error))
      throw error
    }
  }
)

export const fileCreate = createAsyncThunk('common/fileCreate', async (params, {dispatch}) => {
  try {
    dispatch(setLoading(true))
    const response = await createFileClient.create(
      params?.SourceId,
      params?.SourceTypeId,
      params?.FormFile
    )
    dispatch(setFile(response))
    return response
  } catch (error) {
    AuthCheck(error)
    dispatch(setError(error))
    throw error
  }
})

export const fileFolderCreate = createAsyncThunk(
  'common/fileFolderCreate',
  async (params, {dispatch}) => {
    try {
      dispatch(setLoading(true))
      const response = await createFileFolderClient.create(params)
      dispatch(setFileFolder(response))
      return response
    } catch (error) {
      AuthCheck(error)
      dispatch(setError(error))
      throw error
    }
  }
)

export const fileFolderRename = createAsyncThunk(
  'common/fileFolderRename',
  async (params, {dispatch}) => {
    try {
      dispatch(setLoading(true))
      const response = await renameFileFolderClient.update(params)
      dispatch(setFileFolder(response))
      return response
    } catch (error) {
      AuthCheck(error)
      dispatch(setError(error))
      throw error
    }
  }
)

export const fileDownloadAsZip = createAsyncThunk(
  'common/fileDownloadAsZip',
  async (params, {dispatch}) => {
    try {
      dispatch(setLoading(true))
      const token = localStorage.getItem('accessToken')
      const response = await fetch(
        `${window.ENVVARS.REACT_APP_SERVICE_URL}/api/v1/file/DownloadAsZip`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({FileIds: params.fileIds}),
        }
      )
      dispatch(setLoading(false))
      if (!response.ok) throw new Error('Download failed')
      const blob = await response.blob()
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = `dosyalar_${Date.now()}.zip`
      a.click()
      window.URL.revokeObjectURL(url)
      return true
    } catch (error) {
      AuthCheck(error)
      dispatch(setError(error))
      throw error
    }
  }
)

export const fileRename = createAsyncThunk('common/fileRename', async (params, {dispatch}) => {
  try {
    dispatch(setLoading(true))
    const response = await renameFileClient.update(params)
    dispatch(setFileFolder(response))
    return response
  } catch (error) {
    AuthCheck(error)
    dispatch(setError(error))
    throw error
  }
})

export const fileFolderGetAll = createAsyncThunk(
  'common/fileFolderGetAll',
  async (params, {dispatch}) => {
    try {
      dispatch(setLoading(true))
      const response = await getAllFolderWithFilesClient.getAll(params)
      dispatch(setGetAllWithFiles(response))
      return response
    } catch (error) {
      AuthCheck(error)
      dispatch(setError(error))
      throw error
    }
  }
)

export const fileFolderGetId = createAsyncThunk(
  'common/fileFolderGetId',
  async (params, {dispatch}) => {
    try {
      dispatch(setLoading(true))
      const response = await getRootFileFolderIdClient.getAll(params)
      dispatch(setGetFileFolderId(response))
      return response
    } catch (error) {
      AuthCheck(error)
      dispatch(setError(error))
      throw error
    }
  }
)

export const fileFolderGetAllOnlyFolder = createAsyncThunk(
  'common/fileFolderGetAllOnlyFolder',
  async (params, {dispatch}) => {
    try {
      dispatch(setLoading(true))
      const response = await getFileFolderClient.getAll(params)
      dispatch(setGetAllOnlyFolder(response))
      return response
    } catch (error) {
      AuthCheck(error)
      dispatch(setError(error))
      throw error
    }
  }
)

export const fileFolderUpdate = createAsyncThunk(
  'common/fileFolderUpdate',
  async (params, {dispatch}) => {
    try {
      dispatch(setLoading(true))
      const response = await updateFileFolderClient.update(params)
      dispatch(setUpdateFolder(response))
      return response
    } catch (error) {
      AuthCheck(error)
      dispatch(setError(error))
      throw error
    }
  }
)

export const assignFileFolderPermission = createAsyncThunk(
  'common/assignFileFolderPermission',
  async (params, {dispatch}) => {
    try {
      dispatch(setLoading(true))
      const response = await assignFileFolderPermissionClient.assignPermission(params)
      dispatch(setAssignFileFolderPermission(response))
      return response
    } catch (error) {
      AuthCheck(error)
      dispatch(setError(error))
      throw error
    }
  }
)

export const fileFolderPermission = createAsyncThunk(
  'common/fileFolderPermission',
  async (params, {dispatch}) => {
    try {
      dispatch(setLoading(true))
      const response = await getFileFolderPermissionClient.getPermission(params.FileFolderId, params.SourceId, params.SourceTypeId)
      dispatch(setFileFolderPermission(response))
      return response
    } catch (error) {
      AuthCheck(error)
      dispatch(setError(error))
      throw error
    }
  }
)

export const muteFileFolder = createAsyncThunk(
  'common/muteFileFolder',
  async (params, {dispatch}) => {
    try {
      dispatch(setLoading(true))
      const response = await muteFileFolderClient.mute(params)
      dispatch(setMuteFileFolderResult(response))
      return response
    } catch (error) {
      AuthCheck(error)
      dispatch(setError(error))
      throw error
    }
  }
)

export const unmuteFileFolder = createAsyncThunk(
  'common/unmuteFileFolder',
  async (params, {dispatch}) => {
    try {
      dispatch(setLoading(true))
      const response = await unmuteFileFolderClient.unmute(params.fileFolderId, params.sourceId, params.sourceTypeId)
      dispatch(setUnmuteFileFolderResult(response))
      return response
    } catch (error) {
      AuthCheck(error)
      dispatch(setError(error))
      throw error
    }
  }
)

// Slice
const commonSlice = createSlice({
  name: 'common',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload
    },
    setError: (state, action) => {
      state.error = action.payload
      state.loading = false
    },
    setHistory: (state, action) => {
      state.history = action.payload
      state.loading = false
    },
    setNote: (state, action) => {
      state.note = action.payload
      state.loading = false
    },
    setNoteImages: (state, action) => {
      state.noteImages = action.payload
      state.loading = false
    },
    setNoteCreated: (state, action) => {
      state.noteCreated = action.payload
      state.loading = false
    },
    setDeleted: (state) => {
      state.isDeleted = true
      state.loading = false
    },
    setSearch: (state, action) => {
      state.search = action.payload
      state.loading = false
    },
    setGeneralDashResult: (state, action) => {
      state.generalDashResult = action.payload
      state.loading = false
    },
    setBankCashDashResult: (state, action) => {
      state.bankCashDashResult = action.payload
      state.loading = false
    },
    setCurrencyInfos: (state, action) => {
      state.currencyInfos = action.payload
    },
    setActivity: (state, action) => {
      state.activity = action.payload
      state.loading = false
    },
    setFile: (state, action) => {
      state.file = action.payload
      state.loading = false
    },
    setFileFolder: (state, action) => {
      state.fileFolder = action.payload
      state.loading = false
    },
    setGetAllWithFiles: (state, action) => {
      state.getAllWithFiles = action.payload
      state.loading = false
    },
    setGetFileFolderId: (state, action) => {
      state.getFileFolderId = action.payload
      state.loading = false
    },
    setGetAllOnlyFolder: (state, action) => {
      state.getAllOnlyFolder = action.payload
      state.loading = false
    },
    setUpdateFolder: (state, action) => {
      state.updateFolder = action.payload
      state.loading = false
    },
    setAssignFileFolderPermission: (state, action) => {
      state.assignFileFolderPermission = action.payload
      state.loading = false
    },
    setFileFolderPermission: (state, action) => {
      state.fileFolderPermission = action.payload
      state.loading = false
    },
    setMuteFileFolderResult: (state, action) => {
      state.muteFileFolderResult = action.payload
      state.loading = false
    },
    setUnmuteFileFolderResult: (state, action) => {
      state.unmuteFileFolderResult = action.payload
      state.loading = false
    },
    resetState: (state) => {
      Object.assign(state, initialState)
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      (action) => action.type.startsWith('common/') && action.type.endsWith('/pending'),
      (state) => {
        state.loading = true
      }
    )
  }
})

export const {
  setLoading,
  setError,
  setHistory,
  setNote,
  setNoteImages,
  setNoteCreated,
  setDeleted,
  setSearch,
  setGeneralDashResult,
  setBankCashDashResult,
  setCurrencyInfos,
  setActivity,
  setFile,
  setFileFolder,
  setGetAllWithFiles,
  setGetFileFolderId,
  setGetAllOnlyFolder,
  setUpdateFolder,
  setAssignFileFolderPermission,
  setFileFolderPermission,
  setMuteFileFolderResult,
  setUnmuteFileFolderResult,
  resetState,
} = commonSlice.actions

// Selectors
export const selectCommonLoading = (state) => state.common.loading
export const selectCommonError = (state) => state.common.error
export const selectCommonHistory = (state) => state.common.history
export const selectCommonNote = (state) => state.common.note
export const selectCommonNoteImages = (state) => state.common.noteImages
export const selectCommonNoteCreated = (state) => state.common.noteCreated
export const selectCommonSearch = (state) => state.common.search
export const selectCommonGeneralDashResult = (state) => state.common.generalDashResult
export const selectCommonBankCashDashResult = (state) => state.common.bankCashDashResult
export const selectCommonActivity = (state) => state.common.activity
export const selectCommonFile = (state) => state.common.file
export const selectCommonFileFolder = (state) => state.common.fileFolder
export const selectCommonGetAllWithFiles = (state) => state.common.getAllWithFiles
export const selectCommonGetFileFolderId = (state) => state.common.getFileFolderId
export const selectCommonGetAllOnlyFolder = (state) => state.common.getAllOnlyFolder
export const selectCommonUpdateFolder = (state) => state.common.updateFolder
export const selectCommonAssignFileFolderPermission = (state) => state.common.assignFileFolderPermission
export const selectCommonFileFolderPermission = (state) => state.common.fileFolderPermission

export default commonSlice.reducer
